import React,{useEffect,useState} from 'react';
import ListItem from '../components/ListItem';
import Header from '../components/Header';
import { BrowserRouter as Router,Routes, Route, Link,useParams } from 'react-router-dom';
import '../App.css';


const Sidebar=()=>{

  return (
  <>

  <div className="sidebar">
        <div className="side-box">
          <img src="/img/apt1.png" />
          <div className="side-box-content">
            <h3>Spring View Apartments</h3>
            <p>Read our getting started guide</p>
            <div className="side-box-flex">
              <h4>Section 8 Apartment</h4>
              <a className="applyLink" href="/">Apply</a>
            </div>  
          </div>
        </div>
        <div className="side-box">
          <img src="/img/apt2.png" />
          <div className="side-box-content">
            <h3>Spring View Apartments</h3>
            <p>Read our getting started guide</p>
            <div className="side-box-flex">
              <h4>Section 8 Apartment</h4>
              <a className="applyLink" href="/">Apply</a>  
            </div>  
          </div>
        </div>
        <div className="side-box">
          <img src="/img/apt1.png" />
          <div className="side-box-content">
            <h3>Spring View Apartments</h3>
            <p>Read our getting started guide</p>
            <div className="side-box-flex">
              <h4>Section 8 Apartment</h4>
              <a className="applyLink" href="/">Apply</a>  
            </div>  
          </div>
        </div>
        <div className="side-box">
          <img src="/img/apt2.png" />
          <div className="side-box-content">
            <h3>Spring View Apartments</h3>
            <p>Read our getting started guide</p>
            <div className="side-box-flex">
              <h4>Section 8 Apartment</h4>
              <a className="applyLink" href="/">Apply</a>  
            </div>  
          </div>
        </div>
      </div>

    </>
  );
}

export default Sidebar;